import { ActionPaywallSource } from '../../../dashboard/paywall/paywallTypes';
import usePaywall from '../../../dashboard/paywall/usePaywall';
import { useRunOnceWhenTruthy } from '../../../common/useRunOnceWhenTruthy';
import PaywallFunnelDeployImage from './paywallFunnelDeploy.svg?react'; //temporary until we get a dedicated one
import { PaywallBlockActionDialog } from '../../../dashboard/paywall/PaywallBlockActionDialog';

const TITLE_V2 = 'Get Access to CSV Exports with a Free Trial';
const FEATURE_DESCRIPTION_V2 =
  'Export Salesforce configurations to better understand your setup and share insights with your team. Schedule a meeting with our team to activate your trial.';

const DownloadCsvPaywallBlock = ({ closeDialog }: { closeDialog: () => void }) => {
  const { isPaywallActive, sendEncounterPaywallEvent } = usePaywall();

  useRunOnceWhenTruthy(() => {
    sendEncounterPaywallEvent({
      source: ActionPaywallSource.DOWNLOAD_CSV,
    });
  }, isPaywallActive);

  if (!isPaywallActive) {
    return null;
  }

  return (
    <PaywallBlockActionDialog
      title={TITLE_V2}
      infoText={FEATURE_DESCRIPTION_V2}
      Image={<PaywallFunnelDeployImage />}
      closeDialog={closeDialog}
      source={ActionPaywallSource.DOWNLOAD_CSV}
    />
  );
};

export default DownloadCsvPaywallBlock;
